export const UNAUTHORIZED =
  'Usuário sem permissão ou sessão de usuário deletada.';
export const BAD_REQUEST =
  'Erro ao se conectar ao servidor, contate o suporte.';
